<div #calendar class="mp-calendar">
  <div class="calendar-controls">
    <i class="fas fa-angle-left" [class.disabled]="!canGoToPreviousPeriod()" (click)="previousPeriod()"></i>
    <span class="period-selector" *ngIf="currentView === 'DAY'"
      (click)="showYearList($event)">{{ MonthsLabels[viewedMonth] | translate }} {{ viewedYear }}</span>
    <span class="period-selector" *ngIf="currentView === 'MONTH'" (click)="showDayList($event)">{{ viewedYear }}</span>
    <span class="period-selector" *ngIf="currentView === 'YEAR'" (click)="showDayList($event)">{{ years[0] }}
      - {{ years[years.length - 1] }}</span>
    <i class="fas fa-angle-right" (click)="nextPeriod()"></i>
  </div>
  <ng-container *ngIf="currentView === 'DAY'">
    <div class="calendar-day-headers">
      <span class="day-header">{{ 'CALENDAR.MONDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.TUESDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.WEDNESDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.THURSDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header">{{ 'CALENDAR.FRIDAY_FIRST_LETTER' | translate }}</span>
      <span class="day-header" [class.de-emphasize-no-business-day]="onlyBusinessDays">
        {{ 'CALENDAR.SATURDAY_FIRST_LETTER' | translate }}
      </span>
      <span class="day-header" [class.de-emphasize-no-business-day]="onlyBusinessDays">
        {{ 'CALENDAR.SUNDAY_FIRST_LETTER' | translate }}
      </span>
    </div>
    <div class="calendar-days">
      <span class="padding-cell" *ngFor="let dayPadding of daysPadding"></span>
      <span class="calendar-cell" *ngFor="let dayOfMonth of days"
        [class.selected-start]="isStart(dayOfMonth)"
        [class.selected-end]="isEnd(dayOfMonth)"
        [class.selected-middle]="dayIsBetween(dayOfMonth)"
        [class.disabled]="isBeforeMinDate(dayOfMonth) || !isBusinessDay(dayOfMonth)"
        (click)="!isBeforeMinDate(dayOfMonth) && selectDay(dayOfMonth)">
        <span class="day-number">{{ dayOfMonth }}</span>
      </span>
    </div>
  </ng-container>

  <div class="calendar-years" *ngIf="currentView === 'YEAR'">
    <span class="calendar-cell" *ngFor="let year of years"
      [class.selected]="viewedYear === year"
      [class.disabled]="isYearBeforeMinDate(year)"
      (click)="!isYearBeforeMinDate(year) && selectYear($event, year)">
      {{ year }}
    </span>
  </div>

  <div class="calendar-months" *ngIf="currentView === 'MONTH'">
    <span class="calendar-cell" *ngFor="let month of months"
      [class.selected]="viewedYear === startYear && viewedMonth === month"
      [class.disabled]="isMonthBeforeMinDate(viewedYear, month)"
      (click)="!isMonthBeforeMinDate(viewedYear, month) && selectMonth($event, month)">
      {{ MonthsAbrvLabels[month] | translate }}
    </span>
  </div>

  <div class="hours-sections" *ngIf="timeIntervalAllowed">
    <div class="hour-line">
      <span class="hour-toggle">
        <app-mp-toggle [(toggleState)]="startToggle" (toggleStateChange)="resetTimeField('start')"></app-mp-toggle>
      </span>
      <span class="hour-label">{{ 'CALENDAR.START_HOUR' | translate }}</span>
      <span class="hour-picker" *ngIf="startToggle">
        <app-mp-hour-picker [size]="'small'" [(inputValue)]="startTime">
        </app-mp-hour-picker>
      </span>
    </div>
    <div class="hour-line">
      <span class="hour-toggle">
        <app-mp-toggle [(toggleState)]="endToggle" (toggleStateChange)="resetTimeField('end')"></app-mp-toggle>
      </span>
      <span class="hour-label">{{ 'CALENDAR.END_HOUR' | translate }}</span>
      <span class="hour-picker" *ngIf="endToggle">
        <app-mp-hour-picker [size]="'small'" [(inputValue)]="endTime">
        </app-mp-hour-picker>
      </span>
    </div>
  </div>

  <div class="calendar-actions">
    <app-mp-button class="calendar-action" [color]="'negative'"
      [size]="'medium'" [label]="'CALENDAR.REINITIALIZE'" (buttonClicked)="resetCalendar()"></app-mp-button>
    <app-mp-button class="calendar-action"
      [size]="'medium'" [label]="'GLOBAL.VALIDATE'" (buttonClicked)="confirmSelection()"></app-mp-button>
  </div>
</div>
